import React from 'react';
import { Box } from '@mui/material';
import CountDisplay from './counts/CountDisplay';

interface MilestoneOptionProps {
       name: string;
       exceptionCount: number;
       alertsCount: number;
       notesCount: number;
       generalCommentsCount: number;
       isDefault?: boolean;
       maxWidth?: string;
}

export const MilestoneOption: React.FC<MilestoneOptionProps> = ({
       name,
       exceptionCount,
       alertsCount,
       notesCount,
       generalCommentsCount,
       isDefault = false,
       maxWidth = '100%'
}) => {
       return (
              <Box
                     component="span"
                     sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                            pr: 1,
                            maxWidth
                     }}
              >
                     <Box
                            component="span"
                            sx={{
                                   flex: 1,
                                   overflow: 'hidden',
                                   textOverflow: 'ellipsis',
                                   whiteSpace: 'nowrap',
                                   pr: 1,
                                   fontWeight: 400
                            }}
                            title={name}
                     >
                            {name}
                     </Box>

                     <Box sx={{ ml: 'auto' }}>
                            <CountDisplay
                                   exceptionCount={exceptionCount}
                                   alertsCount={alertsCount}
                                   notesCount={notesCount}
                                   generalCommentsCount={generalCommentsCount}
                                   hideExceptionsAndAlerts={name === "General Comments"}
                                   showTooltip={true}
                                   size="medium"
                                   variant="compact"
                            />
                     </Box>
              </Box>
       );
};

export default MilestoneOption; 